export default "/images/timetables-ruleset.jpg?188b6458b84467ac6e708c352cefa9c7";